import { useEffect, useRef } from 'react';
import { useIsFocused, useNavigation } from '@react-navigation/native';

import { MY_DAY_STEP_STATUS } from '../../../../common/utils/myDay/driverDaySteps';
import { getStartOfDayAfterThis } from './startOfDaySteps';

/**
 * One start of day step for its own page (Run overview, Keys and site access,
 * Recalculate and top up pick, Tickets summary).
 * - day: useDriverDay() result; stepKey: the driverDaySteps key
 * Returns { step, isDone, stepLabel ("Step 3 of 8"), afterThis ("After this: …") }.
 * When the step turns done while the page is in front, the page closes back
 * to Start of day (also when the confirmation was only queued offline).
 */
const useStartOfDayStep = (day, stepKey) => {
	const navigation = useNavigation();
	const isFocused = useIsFocused();
	const { visibleStartSteps, stepByKey, runStarted } = day;
	const step = stepByKey[stepKey] || null;
	const isDone = step?.status === MY_DAY_STEP_STATUS.DONE;
	const stepIndex = visibleStartSteps.findIndex(item => item.key === stepKey);

	const wasDoneRef = useRef(isDone);
	useEffect(() => {
		if (isDone && !wasDoneRef.current && isFocused && navigation.canGoBack()) {
			navigation.goBack();
		}
		wasDoneRef.current = isDone;
	}, [isDone, isFocused, navigation]);

	return {
		step,
		isDone,
		stepLabel: stepIndex >= 0 ? `Step ${stepIndex + 1} of ${visibleStartSteps.length}` : null,
		afterThis: getStartOfDayAfterThis(visibleStartSteps, stepKey, runStarted),
	};
};

export default useStartOfDayStep;
